import { createAction } from '@reduxjs/toolkit'
import { TickerTuple } from 'api/v1/market'
import { SymbolName } from 'types'
import { LastBar, TradeType } from './types'

export const updateTradeTypeAction = createAction<TradeType>(
  'market/updateTradeTypeAction'
)
export const updateAllTickerAction = createAction<
  Record<SymbolName, TickerTuple>
>('market/updateAllTickerAction')
export const updateLastBarAction = createAction<LastBar>(
  'market/updateLastBarAction'
)
